import Vue from 'vue'
import Router from 'vue-router'

import Auth from './auth'
import Layout from './layout'
import Education from './educational'
import School from './school'

Vue.use(Router)

const routes = [...Auth, ...Layout, ...Education, ...School]

export default new Router({
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})
